import UserCardDialog from './user-card-dialog.vue';

export default UserCardDialog;